import React, { Component } from 'react';
var ReactSuperSelect = require('react-super-select')

class HRTSettings extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: false,
			section: 'general',
			addingSetting: false,
			editingSetting: false,
			deletingSetting: false,
			loading: false
		};
	}

	toggleSection = (option) => {
		if (option) {
			this.setState({ section: option.id, error: '' });
		}
	}

	toggleCloudSpeechRec = (e) => {
		if (this.props.data.HRTSettings.general.CloudSpeechRec) {
			this.setState({ editingSetting: 'disablingSpeechRec', loading: false, setting: false })
		} else {
			this.setState({ editingSetting: 'enablingSpeechRec', loading: false, setting: false })
		}
	}

	toggleTransferStatus = (department, value) => (e) => {
		this.props.ws.send(JSON.stringify({ route: 'toggleTransferStatus', department: department, value: value }))
	}

	toggleAllTransferStatus = (value) => (e) => {
		this.props.ws.send(JSON.stringify({ route: 'toggleAllTransferStatus', value: value }))
	}

	confirmCloudSpeechRec = (e) => {
		if (this.state.editingSetting == 'disablingSpeechRec') {
			this.setState({ loading: true });
			this.props.ws.send(JSON.stringify({ route: 'editCloudSpeechRec', enabled: false }))
		} else if (this.state.editingSetting == 'enablingSpeechRec') {
			this.setState({ loading: true });
			this.props.ws.send(JSON.stringify({ route: 'editCloudSpeechRec', enabled: true }))
		}
	}
	add = (type) => e => {
		this.setState({ addingSetting: type, setting: {}, loading: false })
	}
	confirmAdd = (type) => e => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'add' + type, setting: this.state.setting }))
	}

	edit = (type, setting) => e => {
		this.setState({
			editingSetting: type,
			setting: setting,
			loading: false
		})
	}
	editSetting = (setting) => e => {
		var newSetting = Object.assign({}, this.state.setting)
		newSetting[setting] = e.target.value
		this.setState({ setting: newSetting, loading: false })
	}
	confirmSetting = (type) => e => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'edit' + type, setting: this.state.setting }))
	}

	delete = (type, setting) => e => {
		e.stopPropagation()
		this.setState({ deletingSetting: type, setting: setting, loading: false })
	}
	confirmDelete = (type) => e => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'delete' + type, setting: this.state.setting }))
	}

	cancel = () => {
		this.setState({
			editingSetting: false,
			deletingSetting: false,
			addingSetting: false,
			loading: false,
			setting: false,
			selectedObject: false
		})
	}
	checkEnter = () => {

	}
	componentWillReceiveProps(nextProps) {
		if (this.state.loading) {
			this.cancel();
		}
	}
	render() {
		console.log('render');
		console.log(this.state);
		if (this.props.active) {
			var settings, editSetting

			if (this.state.section == 'general') {
				settings = (
					<div>
						<div style={{ color: '#2A6AA9', padding: '25px', justifyContent: 'space-between', fontSize: '30px', lineHeight: '120px', display: 'flex', height: '120px', borderBottom: '2px solid rgba(51,119,153, .3)' }}>
							<div>Cloud Speech Recognition</div>
							<div>
								<div className="toggleSwitch " onClick={this.toggleCloudSpeechRec}>
									<div className={this.props.data.HRTSettings.general.CloudSpeechRec ? "enabledToggle" : "disabledToggle"} title={this.props.data.HRTSettings.general.CloudSpeechRec ? "Enabled" : "Disabled"}></div>
								</div>
							</div>
						</div>

						<div className="viewHeader">
							<h1>Transfer Status for the Following Departments</h1>
						</div>

						<div style={{ color: '#2A6AA9', padding: '25px', justifyContent: 'space-between', fontSize: '30px', lineHeight: '120px', display: 'flex', height: '120px', borderBottom: '2px solid rgba(51,119,153, .3)' }}>
							<div>All Call Center Departments</div>
							<div>
								<div className="toggleSwitch " onClick={this.toggleAllTransferStatus(this.props.data.HRTSettings.general.ComplaintsConcernsTransferStatus && this.props.data.HRTSettings.general.ComplimentsTransferStatus && this.props.data.HRTSettings.general.GeneralInformationTransferStatus && this.props.data.HRTSettings.general.LostFoundTransferStatus ? false : true)}>
									<div className={(this.props.data.HRTSettings.general.ComplaintsConcernsTransferStatus && this.props.data.HRTSettings.general.ComplimentsTransferStatus && this.props.data.HRTSettings.general.GeneralInformationTransferStatus && this.props.data.HRTSettings.general.LostFoundTransferStatus) ? "enabledToggle" : (this.props.data.HRTSettings.general.ComplaintsConcernsTransferStatus == false && this.props.data.HRTSettings.general.ComplimentsTransferStatus == false && this.props.data.HRTSettings.general.GeneralInformationTransferStatus == false && this.props.data.HRTSettings.general.LostFoundTransferStatus == false) ? "disabledToggle" : "halfabledToggle"} title={(this.props.data.HRTSettings.general.ComplaintsConcernsTransferStatus && this.props.data.HRTSettings.general.ComplimentsTransferStatus && this.props.data.HRTSettings.general.GeneralInformationTransferStatus && this.props.data.HRTSettings.general.LostFoundTransferStatus) ? "Enabled" : "Disabled"}></div>
								</div>
							</div>
						</div>

						<div style={{ color: '#2A6AA9', padding: '25px', justifyContent: 'space-between', fontSize: '30px', lineHeight: '120px', display: 'flex', height: '120px', borderBottom: '2px solid rgba(51,119,153, .3)' }}>
							<div>Complaints & Concerns</div>
							<div>
								<div className="toggleSwitch " onClick={this.toggleTransferStatus('ComplaintsandConcerns', this.props.data.HRTSettings.general.ComplaintsConcernsTransferStatus ? false : true)}>
									<div className={this.props.data.HRTSettings.general.ComplaintsConcernsTransferStatus ? "enabledToggle" : "disabledToggle"} title={this.props.data.HRTSettings.general.ComplaintsConcernsTransferStatus ? "Enabled" : "Disabled"}></div>
								</div>
							</div>
						</div>

						<div style={{ color: '#2A6AA9', padding: '25px', justifyContent: 'space-between', fontSize: '30px', lineHeight: '120px', display: 'flex', height: '120px', borderBottom: '2px solid rgba(51,119,153, .3)' }}>
							<div>Compliments</div>
							<div>
								<div className="toggleSwitch " onClick={this.toggleTransferStatus('Compliments', this.props.data.HRTSettings.general.ComplimentsTransferStatus ? false : true)}>
									<div className={this.props.data.HRTSettings.general.ComplimentsTransferStatus ? "enabledToggle" : "disabledToggle"} title={this.props.data.HRTSettings.general.ComplimentsTransferStatus ? "Enabled" : "Disabled"}></div>
								</div>
							</div>
						</div>

						<div style={{ color: '#2A6AA9', padding: '25px', justifyContent: 'space-between', fontSize: '30px', lineHeight: '120px', display: 'flex', height: '120px', borderBottom: '2px solid rgba(51,119,153, .3)' }}>
							<div>General Information</div>
							<div>
								<div className="toggleSwitch " onClick={this.toggleTransferStatus('GeneralInformation', this.props.data.HRTSettings.general.GeneralInformationTransferStatus ? false : true)}>
									<div className={this.props.data.HRTSettings.general.GeneralInformationTransferStatus ? "enabledToggle" : "disabledToggle"} title={this.props.data.HRTSettings.general.GeneralInformationTransferStatus ? "Enabled" : "Disabled"}></div>
								</div>
							</div>
						</div>

						<div style={{ color: '#2A6AA9', padding: '25px', justifyContent: 'space-between', fontSize: '30px', lineHeight: '120px', display: 'flex', height: '120px', borderBottom: '2px solid rgba(51,119,153, .3)' }}>
							<div>Lost & Found</div>
							<div>
								<div className="toggleSwitch " onClick={this.toggleTransferStatus('LostandFound', this.props.data.HRTSettings.general.LostFoundTransferStatus ? false : true)}>
									<div className={this.props.data.HRTSettings.general.LostFoundTransferStatus ? "enabledToggle" : "disabledToggle"} title={this.props.data.HRTSettings.general.LostFoundTransferStatus ? "Enabled" : "Disabled"}></div>
								</div>
							</div>
						</div>


					</div>
				)

				if (this.state.editingSetting == 'disablingSpeechRec') {
					editSetting = (
						<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
							<div className="pop" >
								<div className="viewCloser" onClick={this.cancel}></div>
								<div style={{ textAlign: 'left' }}>When Cloud speech rec is disabled, callers to the IVR application won’t be prompted to provide stop or route names/numbers by voice command. They will be able to enter stop or route numbers using the keypad. Local speech rec, such as asking the system to return to the main menu or repeat information, will still be enabled.</div>
								<br />

								{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmCloudSpeechRec}>Disable Cloud Speech Recognition</div>}
							</div>
						</div>
					)
				} else if (this.state.editingSetting == 'enablingSpeechRec') {
					editSetting = (
						<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
							<div className="pop" >
								<div className="viewCloser" onClick={this.cancel}></div>
								<div style={{ textAlign: 'left' }}>When Cloud speech rec is enabled, callers to the IVR application will be prompted to provide stop and route names/numbers by voice command.</div>
								<br />

								{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmCloudSpeechRec}>Enable Cloud Speech Recognition</div>}
							</div>
						</div>
					)
				}
			} else if (this.state.section == 'FareInformation') {
				settings = []
				for (var setting of this.props.data.HRTSettings.FareInformation) {
					settings.push(
						<div className="dataRow" key={setting.ID} onClick={this.edit('FareInformation', setting)}>
							<span>{setting.Name}</span>
							<span style={{ flex: '0 0 50%', textAlign: 'center' }}>{setting.Fare}</span>
						</div>
					)
				}
				if (this.state.editingSetting == 'FareInformation') {
					editSetting = (
						<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
							<div className="pop" >
								<div className="viewCloser" onClick={this.cancel}></div>
								<div style={{ textAlign: 'left' }}>You are editing fare information for {this.state.setting.Name}</div>
								<br />
								<div className="snazzyInputBox">
									<input className="textInput" type="number" required value={this.state.setting.Fare} onChange={this.editSetting('Fare')} ></input>
									<span className="inputBar"></span><label className="textLabel">Fare Amount</label>
								</div>
								{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmSetting('FareInformation')}>Confirm Fare</div>}
							</div>
						</div>
					)
				}

			} else if (this.state.section == 'TicketLocations') {
				settings = [(<img src={this.props.img.plus} className="plusButton" alt="Add a Role" onClick={this.add('TicketLocations')} />)]
				for (var setting of this.props.data.HRTSettings.TicketLocations) {
					settings.push(
						<div className="dataRow" key={setting.Id} onClick={this.edit('TicketLocations', setting)}>
							<span style={{ flex: '0 0 50%', textAlign: 'left' }}>{setting.Location}</span>
							<span style={{ flex: '0 1 50%', textAlign: 'left' }}>{setting.TicketType}</span>
							<span className="buttonBox" style={{ flex: '0 0 50px' }}>
								<img src={this.props.img.delete} alt="Delete Ticket Location" onClick={this.delete('TicketLocations', setting)} />
							</span>
						</div>
					)
				}
				if (this.state.addingSetting == 'TicketLocations') {
					editSetting = (
						<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
							<div className="pop" >
								<div className="viewCloser" onClick={this.cancel}></div>
								<div className="snazzyInputBox">
									<input className="textInput" type="text" required value={this.state.setting.Location} onChange={this.editSetting('Location')} ></input>
									<span className="inputBar"></span><label className="textLabel">Location</label>
								</div>
								<br />
								<div className="snazzyInputBox">
									<input className="textInput" type="text" required value={this.state.setting.TicketType} onChange={this.editSetting('TicketType')} ></input>
									<span className="inputBar"></span><label className="textLabel">Ticket Type</label>
								</div>
								{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmAdd('TicketLocations')}>Add New Ticket Location</div>}
							</div>
						</div>
					)
				}
				if (this.state.editingSetting == 'TicketLocations') {
					editSetting = (
						<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
							<div className="pop" >
								<div className="viewCloser" onClick={this.cancel}></div>
								<div className="snazzyInputBox">
									<input className="textInput" type="text" required value={this.state.setting.Location} onChange={this.editSetting('Location')} ></input>
									<span className="inputBar"></span><label className="textLabel">Location</label>
								</div>
								<br />
								<div className="snazzyInputBox">
									<input className="textInput" type="text" required value={this.state.setting.TicketType} onChange={this.editSetting('TicketType')} ></input>
									<span className="inputBar"></span><label className="textLabel">Ticket Type</label>
								</div>
								{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmSetting('TicketLocations')}>Confirm Ticket Location</div>}
							</div>
						</div>
					)
				}
				if (this.state.deletingSetting == 'TicketLocations') {
					editSetting = (
						<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
							<div className="pop" >
								<div className="viewCloser" onClick={this.cancel}></div>
								<div style={{ textAlign: 'center' }}>You are removing {this.state.setting.TicketType} from {this.state.setting.Location}</div>
								<br />

								{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmDelete('TicketLocations')}>Delete Ticket Location</div>}
							</div>
						</div>
					)
				}
			} else if (this.state.section == 'MAXRoutes') {
				settings = [(<img src={this.props.img.plus} className="plusButton" alt="Add a Role" onClick={this.add('MAXRoutes')} />)]
				for (var setting of this.props.data.HRTSettings.MAXRoutes) {
					settings.push(
						<div className="dataRow" key={setting.Route_Number} onClick={this.edit('MAXRoutes', setting)}>
							<span>{setting.Route_Number}</span>
							<span className="buttonBox" style={{ flex: '0 0 50px' }}>
								<img src={this.props.img.delete} alt="Delete Max Route" onClick={this.delete('MAXRoutes', setting)} />
							</span>
						</div>
					)
				}
				if (this.state.addingSetting == 'MAXRoutes') {
					editSetting = (
						<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
							<div className="pop" >
								<div className="viewCloser" onClick={this.cancel}></div>
								<div className="snazzyInputBox">
									<input className="textInput" type="text" required value={this.state.setting.Route_Number} onChange={this.editSetting('Route_Number')} ></input>
									<span className="inputBar"></span><label className="textLabel">Route Number</label>
								</div>
								<br />
								{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmAdd('MAXRoutes')}>Add New Max Route</div>}
							</div>
						</div>
					)
				}
				if (this.state.deletingSetting == 'MAXRoutes') {
					editSetting = (
						<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
							<div className="pop" >
								<div className="viewCloser" onClick={this.cancel}></div>
								<div style={{ textAlign: 'center' }}>You are removing {this.state.setting.Route_Number}</div>
								<br />

								{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmDelete('MAXRoutes')}>Delete Max Route</div>}
							</div>
						</div>
					)
				}
			}

			return (
				<div className="viewContent" id="reportView" >
					<div style={{ display: 'flex' }}>
						<ReactSuperSelect style={{ flex: '1 0 150px', margin: '0px', display: 'inline-block' }} onChange={this.toggleSection} initialValue={{ id: 'general', name: 'General Settings' }} placeholder={"Settings Group"} clearable={false} closeOnSelectedOptionClick={false} dataSource={[{ id: 'general', name: 'General Settings' }, { id: 'FareInformation', name: 'Fare Information' }, { id: 'TicketLocations', name: 'Ticket Locations' }, { id: 'MAXRoutes', name: '757 Routes' }]} />
					</div>
					<div style={{ overflow: 'auto', height: 'calc(100% - 45px)' }}>
						{settings}
					</div>
					{editSetting}
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}



const icon = "menuGear"
const roles = ["View"]
export { HRTSettings, icon, roles }


// WEBPACK FOOTER //
// ./src/Views/HRTSettings.js